import React, { useMemo } from 'react';
import { Dropdown } from '@balance-web/dropdown-v2';

import type { NestedPage } from './types';
import { isPageSelected } from './isPageSelected';

export const NavigationItemAsDropdownMenu = ({
  page,
  selectedPage,
  testid,
}: {
  page: NestedPage;
  selectedPage: string;
  testid?: string;
}) => {
  const isSelected = useMemo(() => {
    return isPageSelected(page, selectedPage);
  }, [page, selectedPage]);

  if (page.options) {
    const submenuDataAttribtues = page.testid
      ? { testid: `${page.testid}-navigation-dropdown` }
      : {};

    return (
      <Dropdown.SubMenu data={submenuDataAttribtues}>
        <Dropdown.SubMenuTrigger
          selected={isSelected}
          selectedLabel={page.label}
        >
          {page.label}
        </Dropdown.SubMenuTrigger>
        {page.options.map((option) => {
          const optionsDataAttributes = option.testid
            ? { testid: option.testid }
            : {};
          return (
            <Dropdown.Item
              key={`${page.label}-${option.label}`}
              data={optionsDataAttributes}
              href={option.href}
              selected={isPageSelected(option, selectedPage)}
              selectedLabel={option.label}
              value={`${page.label}-${option.label}`}
            >
              {option.label}
            </Dropdown.Item>
          );
        })}
      </Dropdown.SubMenu>
    );
  }

  return (
    <Dropdown.Item
      href={page.href}
      selected={isSelected}
      selectedLabel={page.label}
      value={page.label}
    >
      {page.label}
    </Dropdown.Item>
  );
};
